import styled from 'styled-components';

const TripleImageStyle = styled.div`
	&.tripleImageCont {
		.first_img,
		.second_img,
		.third_img {
			margin-bottom: var(--portfolioItemMarg);

			> div {
				padding-top: 175%;
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		&.tripleImageCont {
			display: flex;
			flex-wrap: wrap;
			margin-right: calc((var(--portfolioItemMarg) / 2) * -1);
			margin-left: calc((var(--portfolioItemMarg) / 2) * -1);

			.first_img,
			.second_img,
			.third_img {
				flex: 0 0 33.33333%;
				margin-bottom: 0;
				padding-left: calc(var(--portfolioItemMarg) / 2);
				padding-right: calc(var(--portfolioItemMarg) / 2);
			}
		}
	}
`;

export default TripleImageStyle;
